import { render } from "./new.html?vue&type=template&id=b96bcfbe&ts=true"
import script from "./new.ts?vue&type=script&lang=ts"
export * from "./new.ts?vue&type=script&lang=ts"

import "./new.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__